"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const component_text_1 = require("@patternplate/component-text");
const InnerMarkdownItem = (props) => {
    return (React.createElement("li", { className: props.className },
        React.createElement(component_text_1.Text, null, props.children)));
};
exports.MarkdownItem = styled_components_1.default(InnerMarkdownItem) `
  grid-column: first / span 12;
  font-size: 18px;
  line-height: 27px;
  color: ${props => props.theme.colors.color};
  margin-top: 4.5px;
`;
//# sourceMappingURL=markdown-item.js.map